import React, { Component } from 'react';
import Select from 'react-select';
import Switch from "react-switch";
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'qrcode.react';

import { Row, Col, PanelGroup, Panel, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import DatosPersonales from "./Content/DatosPersonales";
import Requisitos from "./Content/Requisitos";
import RequisitosAdjuntos from "./Content/RequisitosAdjuntos";
import CustomModalPerfil from "../../components/Modal/CustomModalPerfil";

import { guardar, sendFiles, PeriodosDisp, CarrerasDisp, consultaRequisitos, datosSelect, ConsultIntervalo,
        SvgToPng, DelSolicitud } from "../../funciones/AdmisionFunction";
import { consultaDataUser2 } from '../../funciones/InscripcionFunction';

import { consultaGeneral } from '../../funciones/PefilFunction';

import ModalReports from '../../components/Reportes/ModalReports';
import PlanillaAdmision from '../../components/Reportes/PlanillaAdmision';
import PlanillaAdmisionSend from '../../components/Reportes/PlanillaAdmisionSend';

import { pdf } from '@react-pdf/renderer';
import { copyFile } from '../../funciones/AdmisionFunction';

import Documentos from '../../components/Reportes/Documentos';

let button1 = true;
let status = "";
let statusUser = "";
let periodo = "";
let carrera = "";
let token = "";
let fecha = "";
let cita = "";

let unCr = 0;
let unBs = 0;
let cuotas = "";
let cuotaN = "";

class Admision extends Component {
    state = {
        notificacionClass: "custom-alert-info",
        notificacionIcon: "fa fa-circle-o-notch fa-spin",
        notificacionText: "Verificando Información, espera por favor",
        notificacionText2: "",
        notificacionStyles: {
            fontSize:12, position:"absolute", top: 5
        },

        periodoSelect: { value: '', label: ' - Selecciona un Periodo - ' },
        periodos: [],
        carreraSelect: { value: '', label: ' - Selecciona una Carrera - ' },
        carreras: [],
        perfil: true,
        iconChevron1: "fa fa-chevron-down",
        btnDown1: true,
        documentos: true,
        iconChevron2: "fa fa-chevron-down",
        btnDown2: true,
        button: {
            icon:"fa fa-paper-plane",
            text:"Enviar Solicitud"
        },
        button2: {
            icon:"fa fa-print",
            text:"Imprimir Planillas"
        },
        DatosPersonales: [{
            apellido1: {status: "", text: ""},
            apellido1Repre: {status: "", text: ""},
            apellido2: {status: "", text: ""},
            apellido2Repre: {status: "", text: ""},
            calle: {status: "", text: ""},
            calleRepre: {status: "", text: ""},
            casa: {status: "", text: ""},
            casaRepre: {status: "", text: ""},
            cedula: {status: "", text: ""},
            cedulaRepre: {status: "", text: ""},
            emailRepre: {status: "", text: ""},
            etnia: {status: "", text: ""},
            fecha: "",
            nombre1: {status: "", text: ""},
            nombre1Repre: {status: "", text: ""},
            nombre2: {status: "", text: ""},
            nombre2Repre: {status: "", text: ""},
            pasaporte: {status: "", text: ""},
            pasaporteRepre: {status: "", text: ""},
            selectCiudad: {label: "", status: "", value: ""},
            selectCiudadDir: {label: "", status: "", value: ""},
            selectCiudadRepre: {label: "", status: "", value: ""},
            selectEstado: {label: "", status: "", value: ""},
            selectEstadoDir: {label: "", status: "", value: ""},
            selectEstadoRepre: {label: "", status: "", value: ""},
            selectMunicipio: {label: "", status: "", value: ""},
            selectMunicipioDir: {label: "", status: "", value: ""},
            selectMunicipioRepre: {label: "", status: "", value: ""},
            selectNac: {label: "", value: ""},
            selectNacr: {label: "", value: ""},
            selectPais: {label: "", status: "", value: ""},
            selectPaisDir: {label: "", status: "", value: ""},
            selectPaisRepre: {label: "", status: "", value: ""},
            selectParroquia: {label: "", status: "", value: ""},
            selectParroquiaDir: {label: "", status: "", value: ""},
            selectParroquiaRepre: {label: "", status: "", value: ""},
            tlf1: {status: "", text: ""},
            tlf1Repre: {status: "", text: ""},
            tlf2: {status: "", text: ""},
            tlf2Repre: {status: "", text: ""},
            tlf3: {status: "", text: ""},
            tlf3Repre: {status: "", text: ""},
            valorSex: {label: "", value: ""},
            edad:0,
        }],
        cantErrores: "",
        openW: false,
        openW2: false,
        openW3: false,
        openModal: false,
        requisitos: [],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando lista de requisitos</React.Fragment>,
        requisitosCon: [],
        boton1C: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        diasEntrega: <i className="fa fa-spinner fa-spin"></i>,
        qr: "",
        
        seccionesSelectFull: [],
        InscripcionDatos: "",
        tipoInsc: "",
        periodoAct: "",
        datosPersonales: "",
        costoInsc: "",
        qrInsc: "",
        file1: "",
        file2: "",
        file3: "",
        file4: ""
    }

    constructor (props) {
        super (props)

        consultaDataUser2 ((resp) => {
            unCr= resp[2]
            unBs= resp[5]
            cuotas = resp[6]
            cuotaN = resp[7]
            this.setState(resp[0])
            if(resp[0].InscripcionDatos !== "") {
                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp[0].InscripcionDatos.token).substring(0,10)}`}/>
                )
    
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
    
                SvgToPng (dataUri, (qr) => {
                    this.setState({ qrInsc: qr })
                })
            }
        })

        PeriodosDisp ((resp)=> {
            this.setState({periodos:resp})
        })
        consultaRequisitos ((resp)=> {
            if (resp.length === 0) {
                this.setState({ preloader: "No existen requisitos registrados" })
            }else{
                this.setState({ requisitos: resp })
            }
        })
        /* datosSelect ((resp) => {
            button1 = false;
            statusUser = resp[4];
            if (resp[0] !== null){
                status = resp[3];
                let periodoSelect = { value: '', label: ' - Selecciona un Periodo - ' }
                let carreraSelect = { value: '', label: ' - Selecciona una Carrera - ' }
                let requisitosCon = []

                if (resp[0] !== undefined) requisitosCon = resp[0];
                if (resp[1].value !== undefined) periodoSelect = resp[1];
                if (resp[2].value !== undefined) carreraSelect = resp[2];

                periodo = periodoSelect;
                carrera = carreraSelect;
                token = resp[5];
                fecha = resp[6];
                cita = resp[7];

                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${token.substring(0,10)}`}/>
                )
                
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;


                SvgToPng (dataUri, (qr) => {
                    this.setState({
                        requisitosCon: requisitosCon,
                        periodoSelect: periodoSelect,
                        carreraSelect: carreraSelect,
                        qr: qr
                    }, () => {
                        CarrerasDisp (this.state.periodoSelect.value, (resp) => {
                            this.setState({
                                carreras: resp
                            })
                        })
                    })
                })
            }

            this.notificacion();
        }) */

        consultaGeneral((resp) => {
            let data = resp[0];
            let contenido = this.state.DatosPersonales[0];
            for (let i in contenido) {
                contenido[i] = data[i]
            }
            this.setState({
                DatosPersonales: [contenido]
            })
        })

        ConsultIntervalo((resp) => {
            this.setState({diasEntrega: `${resp[0]} dia(s)`})
        })
    }

    

    componentDidMount = () => {
        datosSelect ((resp) => {
            button1 = false;
            statusUser = resp[4];
            if (resp[0] !== null){
                status = resp[3];
                let periodoSelect = { value: '', label: ' - Selecciona un Periodo - ' }
                let carreraSelect = { value: '', label: ' - Selecciona una Carrera - ' }
                let requisitosCon = []

                if (resp[0] !== undefined) requisitosCon = resp[0];
                if (resp[1].value !== undefined) periodoSelect = resp[1];
                if (resp[2].value !== undefined) carreraSelect = resp[2];

                periodo = periodoSelect;
                carrera = carreraSelect;
                token = resp[5];
                fecha = resp[6];
                cita = resp[7];

                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${token.substring(0,10)}`}/>
                )
                
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;


                SvgToPng (dataUri, (qr) => {
                    this.setState({
                        requisitosCon: requisitosCon,
                        periodoSelect: periodoSelect,
                        carreraSelect: carreraSelect,
                        qr: qr
                    }, () => {
                        CarrerasDisp (this.state.periodoSelect.value, (resp) => {
                            this.setState({
                                carreras: resp
                            })
                        })
                    })
                })
            }

            this.notificacion();
        })
    }

    valorPeriodo = (periodoSelect) => {
        this.setState({
            periodoSelect,
            carreras: [{value: '', label: ' - Buscando Carreras - '}]
        }, () => {
            CarrerasDisp (periodoSelect.value, (resp) => {
                this.setState({
                    carreras: resp
                })
            })
        })
    }

    notificacion = () => {
        switch (status) {
            case "":
                switch (parseInt(statusUser)) {
                    case 1:
                        this.setState({
                            notificacionClass: "custom-alert-success",
                            notificacionIcon: "fa fa-info-circle",
                            notificacionText: "Completa los campos para realizar el proceso de admisión",
                            notificacionText2: "",
                            notificacionStyles: {
                                fontSize:12, position:"absolute", top: 5
                            }
                        })
                        return null;
                    case 2:
                        this.setState({
                            notificacionClass: "custom-alert-danger",
                            notificacionIcon: "fa fa-times",
                            notificacionText: "Tienes abierta una solicitud de datos de perfil. Espera que esta solicitud sea rechazada para poder realizar el proceso de admisión",
                            notificacionText2: "",
                            notificacionStyles: {
                                fontSize:12, position:"absolute", top: 15
                            }
                        })
                        return null;
                    case 3:
                        this.setState({
                            notificacionClass: "custom-alert-warning",
                            notificacionIcon: "fa fa-exclamation-triangle",
                            notificacionText: "Actualmente tu cuenta esta validada y no necesitas realizar el proceso de admisión",
                            notificacionText2: "",
                            notificacionStyles: {
                                fontSize:12, position:"absolute", top: 5
                            }
                        })
                        return null;
                    case 4:
                        this.setState({
                            notificacionClass: "custom-alert-success",
                            notificacionIcon: "fa fa-info-circle",
                            notificacionText: "Completa los campos para realizar el proceso de admisión",
                            notificacionText2: "",
                            notificacionStyles: {
                                fontSize:12, position:"absolute", top: 5
                            }
                        })
                        return null;
                    case 5:
                        this.setState({
                            notificacionClass: "custom-alert-success",
                            notificacionIcon: "fa fa-info-circle",
                            notificacionText: "Completa los campos para realizar el proceso de admisión",
                            notificacionText2: "",
                            notificacionStyles: {
                                fontSize:12, position:"absolute", top: 5
                            }
                        })
                        return null;
                    default:
                        return null;
                }
            case "0":
                this.setState({
                    notificacionClass: "custom-alert-info",
                    notificacionIcon: "fa fa-check",
                    notificacionText: "Ya realizaste el proceso de admisión. Espera un email con la respuesta",
                    notificacionText2: "",
                    notificacionStyles: {
                        fontSize:12, position:"absolute", top: 6
                    }
                })
                return null;
            case "1":
                this.setState({
                    notificacionClass: "custom-alert-info",
                    notificacionIcon: "fa fa-check",
                    notificacionText: "Tu admisión está aprobada, lleva la documentación a la institución",
                    notificacionText2: "",
                    notificacionStyles: {
                        fontSize:12, position:"absolute", top: 6
                    }
                })
                return null;
            case "2":
                this.setState({
                    notificacionClass: "custom-alert-info",
                    notificacionIcon: "fa fa-check",
                    notificacionText: "Estas Inscrito",
                    notificacionText2: "",
                    notificacionStyles: {
                        fontSize:12, position:"absolute", top: 6
                    }
                })
                return null;
            default:
                return null;
        }
    }

    valorCarrera = (carreraSelect) => {
        this.setState({carreraSelect})
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content]
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    CambiaStateHijo = (key, campos) => {
        let contenido = this.state.DatosPersonales;
        
        (contenido.length === 0) ? contenido.push({[key]: campos}) : contenido[0][key] = campos;
        
        this.setState({
            DatosPersonales: contenido
        }, () => {
            /* console.log(this.state.DatosPersonales) */
        })
    }

    perfil = () => {
        let { resp0, resp2 } = this.state;
        
        let datosPersonales = () => {

            return(
                <div style={{overflowY: "auto", overflowX: "hidden", height: "67vh"}}>
                    <DatosPersonales resp0 = {resp0} resp2 = {resp2}
                    updState = { (key, campos) => {this.CambiaStateHijo(key, campos)} }/>
                </div>
            )  
        }

        return (
            <Panel eventKey = {true}>
                <Panel.Heading  onClick = {()=> {this.cambiaIcon( "btnDown1", "iconChevron1", "perfil")}}>
                    <Panel.Title toggle className="custom-color">
                        <Row>
                            <Col md={10} style={{fontSize: 12}}>
                                Datos Personales
                            </Col>
                            <Col md={2} align="right">
                                <i className={this.state.iconChevron1}></i>
                            </Col>
                        </Row>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                    {datosPersonales()}
                </Panel.Body>
            </Panel>
        )
    }

    upd = (id, estado) => {
        let { requisitosCon } = this.state;
        let contenido = requisitosCon;
        if (estado === true) {
            if (contenido.includes(id) === false) contenido.push(id)
        }else{
            if (contenido.includes(id) === true) {
                let index = contenido.indexOf(id);
                if (index > -1) {
                    contenido.splice(index, 1);
                }
            } 
        }
        
        this.setState({ requisitosCon: contenido })
    }

    documentos = () => {
        const styles = {
            padding: 5, fontSize: 12
        }

        let listrequisitos = () => {
            let { requisitos, preloader, requisitosCon } = this.state;

            if (requisitos.length === 0) return (
                <tr>
                    <td align="center" colSpan={2}>{preloader}</td>
                </tr>
            )
            
            return (
                requisitos.map(option => (
                    <Requisitos key={option.id} seleccionados = {requisitosCon} datos={option} updLista = {(id, estado) => {this.upd(id, estado)}}/>
                ))
            )
        }

        let doc = () => {
            return(
                <React.Fragment>
                    <div className="text-danger" style={{fontSize: 11}} align="justify">
                        A continuación debes seleccionar los documentos que consignarás. Es importante que lleves todos o la mayoría de documentos exigidos en este listado
                    </div>
                    <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "65vh", overflowX:"hidden"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="50px" style={styles}></td>
                                    <td align="center" width="100%" style={styles}><strong>Requisitos</strong></td>
                                </tr>
                                {listrequisitos()}
                            </tbody>
                        </Table>
                    </div>
                </React.Fragment>
            )
        }

        return (
            <Panel eventKey = {true}>
                <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown2", "iconChevron2", "documentos")}}>
                    <Panel.Title toggle className="custom-color">
                        <Row>
                            <Col md={10} style={{fontSize: 12}}>
                                Documentos a Consignar
                            </Col>
                            <Col md={2} align="right">
                                <i className={this.state.iconChevron2}></i>
                            </Col>
                        </Row>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                    {doc()}
                </Panel.Body>
            </Panel>
        )
    }

    solicitar = () => {
        if (this.state.boton1C.disabled === true) return null;

        this.setState({
            button: {
                icon:"fa fa-spinner fa-spin",
                text:"Espera",
                disabled: true
            },
            boton1C: {
                icon:"fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            },
        }, () => {
            let respGuardar = (resp) => {
                let states = resp[0]
                let mensaje = resp[1]
                let errores = resp[2]
                let nameErrores = resp[3]
                let contentErr = []

                let erroresList = (
                    <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                        <div style={{overflowY: "auto", maxHeight: "40vh"}}>
                            {contentErr}
                        </div>
                    </Popover>
                )

                let Ok = (mensaje) => {
                    datosSelect ((resp) => {
                        this.notificacion();
                        button1 = false;
                        statusUser = resp[4];
                        if (resp[0] !== null){
                            status = resp[3];
                            let periodoSelect = { value: '', label: ' - Selecciona un Periodo - ' }
                            let carreraSelect = { value: '', label: ' - Selecciona una Carrera - ' }
                            let requisitosCon = []
            
                            if (resp[0] !== undefined) requisitosCon = resp[0];
                            if (resp[1].value !== undefined) periodoSelect = resp[1];
                            if (resp[2].value !== undefined) carreraSelect = resp[2];
            
                            periodo = periodoSelect;
                            carrera = carreraSelect;
                            token = resp[5];
                            fecha = resp[6];
                            cita = resp[7];


                            /* let imgSvg = (
                                <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${token.substring(0,10)}`}/>
                            )
                            
                            const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                            const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
                            this.setState({
                                openW: false,
                                openW2: true,
                                openW3: false
                            }) */

                            consultaDataUser2 ((resp2) => {
                                unCr= resp2[2]
                                unBs= resp2[5]
                                cuotas = resp2[6]
                                cuotaN = resp2[7]
                                this.setState(resp2[0])
                                
                                if(resp2[0].InscripcionDatos !== "") {
                                    let imgSvg = (
                                        <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp2[0].InscripcionDatos.token).substring(0,10)}`}/>
                                    )
                        
                                    const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                                    const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
                        
                                
                                    SvgToPng (dataUri, (qr) => {
                                        this.setState({
                                            requisitosCon: requisitosCon,
                                            periodoSelect: periodoSelect,
                                            carreraSelect: carreraSelect,
                                            qr: qr,
                                            button: {
                                                icon:"fa fa-paper-plane",
                                                text:"Enviar Solicitud"
                                            },
                                            boton1C: {
                                                icon: "fa fa-check",
                                                text: "Si",
                                                disabled: false
                                            },
                                        }, () => {
                                            CarrerasDisp (this.state.periodoSelect.value, (resp) => {
                                                this.setState({
                                                    carreras: resp
                                                })
                                            })
                                            
                                            /* Enviar documentos al correo */
                                            this.setState({
                                                button: {
                                                    icon:"fa fa-spinner fa-spin",
                                                    text:"Enviando",
                                                    disabled: true
                                                },
                                                boton1C: {
                                                    icon: "fa fa-spinner fa-spin",
                                                    text: "Enviando Documentos",
                                                    disabled: true
                                                }
                                            }, () => {
                                                let { requisitos, requisitosCon, DatosPersonales, qr, seccionesSelectFull, InscripcionDatos,
                                                    tipoInsc, periodoAct, datosPersonales, costoInsc, qrInsc } = this.state;
                
                                                let {file1, file2, file3, file4} = this.state;
                                                let nombre1 = this.state.DatosPersonales[0].nombre1.text;
                                                let nombre2 = this.state.DatosPersonales[0].nombre2.text;
                                                let apellido1 = this.state.DatosPersonales[0].apellido1.text;
                                                let apellido2 = this.state.DatosPersonales[0].apellido2.tex
                                                let nac = this.state.DatosPersonales[0].selectNac.value;
                                                let ci = this.state.DatosPersonales[0].cedula.text;

                                                let archivoPdf = (<Documentos file1 = {file1} file2 = {file2} file3 = {file3} file4 = {file4}
                                                    nac = {nac} ci = {ci} nombre1 = {nombre1} nombre2 = {nombre2} apellido1 = {apellido1} apellido2 = {apellido2}/>)
                                                
                                                let dat = "";

                                                if (seccionesSelectFull.length > 0) dat = seccionesSelectFull;
                                                
                                                /* console.log({
                                                    dat,
                                                    token
                                                }); */
                                                
                                                let planillaPdf = (<PlanillaAdmisionSend
                                                        requisitos = {requisitos}
                                                        requisitosCon = {requisitosCon}
                                                        datos = {DatosPersonales[0]}
                                                        periodo = {periodo}
                                                        carrera = {carrera}
                                                        token = {token}
                                                        fecha = {fecha}
                                                        cita = {cita}
                                                        qrCode = {qr}
                                                        
                                                        dataM = {seccionesSelectFull}
                                                        dataInscripcion = {InscripcionDatos}
                                                        tipoInsc = {tipoInsc}
                                                        periodo2 = {periodoAct}
                                                        dataEst = {datosPersonales}
                                                        cuotas = {cuotas}
                                                        cuotaN = {cuotaN}
                                                        creditos = {unCr}
                                                        monto = {unBs}
                                                        inscripcion = {costoInsc}
                                                        qr = {qrInsc}
                                                    />
                                                )
                                                
                                                const generateBlob = async (callback) => {
                                                    const blob = await pdf(archivoPdf).toBlob();
                                                    callback(blob)
                                                };

                                                const generatePlanilla = async (callback) => {
                                                    const blob = await pdf(planillaPdf).toBlob();
                                                    callback(blob)
                                                };

                                                const SendOk = (mensaje) => {
                                                    this.setState({
                                                        openW: false,
                                                        openW2: false,
                                                        openW3: false,
                                                        button: { icon:"fa fa-paper-plane", text: "Enviar Solicitud", disabled: false },
                                                        boton1C: { icon: "fa fa-check", text: "Si", disabled: false }
                                                    }, () => {
                                                        toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
                                                    });
                                                }

                                                generateBlob((respPdf) => {
                                                    generatePlanilla((respPlanilla) => {
                                                        let campos = {
                                                            campos: this.state.DatosPersonales,
                                                            file1: this.state.file1,
                                                            file2: this.state.file2,
                                                            file3: this.state.file3,
                                                            file4: this.state.file4,
                                                            filePdf: respPdf,
                                                            filelamilla: respPlanilla
                                                        }
                                                        /* Primer Intento */
                                                        sendFiles(campos, (respF1) => {
                                                            if (respF1.status === "Error"){
                                                                this.setState({
                                                                    button: { icon:"fa fa-spinner fa-spin", text:"Reintentando (1)", disabled: true },
                                                                    boton1C: { icon: "fa fa-spinner fa-spin", text: "Reintentando (1)", disabled: true }
                                                                }, () => {
                                                                    /* Segundo Intento */
                                                                    sendFiles(campos, (respF2) => {
                                                                        if (respF2.status === "Error"){
                                                                            this.setState({
                                                                                button: { icon:"fa fa-spinner fa-spin", text:"Reintentando (2)", disabled: true },
                                                                                boton1C: { icon: "fa fa-spinner fa-spin", text: "Reintentando (2)", disabled: true }
                                                                            }, () => {
                                                                                /* Tercer Intento */
                                                                                sendFiles(campos, (respF3) => {
                                                                                    if (respF3.status === "Error"){
                                                                                        /* DelSolicitud */
                                                                                        DelSolicitud(() => {
                                                                                            status = "";
                                                                                            statusUser = 1;
                                                                                            this.setState({
                                                                                                openW: false,
                                                                                                openW2: false,
                                                                                                openW3: false,
                                                                                                button: { icon:"fa fa-paper-plane", text: "Enviar Solicitud", disabled: false },
                                                                                                boton1C: { icon: "fa fa-check", text: "Si", disabled: false }
                                                                                            }, () => {
                                                                                                toast.error(respF3.mess,{autoClose: 8000});
                                                                                            });
                                                                                        })
                                                                                    }else{
                                                                                        SendOk(mensaje)
                                                                                    }
                                                                                })
                                                                            })
                                                                        }else{
                                                                            SendOk(mensaje)  
                                                                        }
                                                                    })
                                                                })
                                                            }else{
                                                                SendOk(mensaje)
                                                            }
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                }
                            })
                            
                        }else{
                            this.setState({
                                button: {
                                    icon:"fa fa-paper-plane",
                                    text:"Enviar Solicitud"
                                },
                                boton1C: {
                                    icon: "fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                                openW: false,
                                openW2: false,
                                openW3: false,
                            }, () => {
                                CarrerasDisp (this.state.periodoSelect.value, (resp) => {
                                    this.setState({
                                        carreras: resp
                                    })
                                }),
                                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
                            })
                        }
                    })
                }

                for (let i in nameErrores) {
                    if (nameErrores[i] !== "") contentErr.push(
                        <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
                    )
                }

                if (errores === 0){
                    consultaDataUser2 ((resp2) => {
                        unCr= resp2[2]
                        unBs= resp2[5]
                        cuotas = resp2[6]
                        cuotaN = resp2[7]
                        this.setState(resp2[0])
                        if(resp2[0].InscripcionDatos !== "") {
                            let imgSvg = (
                                <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp2[0].InscripcionDatos.token).substring(0,10)}`}/>
                            )
                
                            const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                            const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
                
                            SvgToPng (dataUri, (qr) => {
                                this.setState({
                                    qrInsc: qr,
                                    cantErrores:"" 
                                })
                            })
                        }
                    })
                }

                if (mensaje[0].status === "error" && errores !== 0) this.setState ({
                    cantErrores: <div style={{paddingTop:10}}>
                                    Se han encontrado {errores} error(es). Haz click <span>
                                    <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                        <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                                    </OverlayTrigger></span> para verlos
                                </div>
                })
        
                Ok(mensaje[0]);
            }

            let campos = {
                campos: this.state.DatosPersonales,
                periodo: this.state.periodoSelect,
                carrera: this.state.carreraSelect,
                requisitos: this.state.requisitosCon,
                file1: this.state.file1,
                file2: this.state.file2,
                file3: this.state.file3,
                file4: this.state.file4
            }

            guardar(campos, (resp) => {
                respGuardar(resp)
            })

        })
    }

    closeWindow = () => (e) => {
        this.setState({
            openW2: false,
            openW3: false,
        })
    }

    modalPago = () => {
        let { openW3 } = this.state;
        let inscript = this.state.costoInsc

        let contenidoModal = () => {
            if (status === "1") return (
                <React.Fragment>
                    <div className="text-danger">
                        Total a pagar <strong>{(parseFloat(unBs) + parseFloat(inscript.replace(' Bs.', ''))).toFixed(2)} Bs.</strong>
                    </div>
                    <div style={{fontSize: 12}}>Si ya realizaste la transferencia ve a <strong>ESTADO DE CUENTA</strong> para registrarla y agilizar el proceso</div>
                </React.Fragment>
            )
            return null;
        }

        return (
            <CustomModalPerfil
                isopen =  {openW3}
                titulo = {<div className="text-primary">Proceso Completado</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className="fa fa-times"></i> Ok</React.Fragment>}
                boton2 = ""
                funcion1 = {() => { this.setState({openW3: false}) }}
                updState = {() => { return null }}/>
        )
    }

    showModal = () => {
        let { openW2, boton1C } = this.state;

        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas realmente Solicitar la Admisión?</div>
                <div style={{fontSize:10}}>
                    Asegúrate de haber revisado toda la información e imprime la planilla luego de aceptar
                </div>
                <div style={{fontSize:10}}>
                    <strong className="text-danger">Nota: Luego de hacer el proceso de admisión deberás llevar la documentación en el dia indicado en la planilla, de lo contrario tu solicitud será rechazada automáticamente</strong>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModalPerfil
                isopen =  {openW2}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className={boton1C.icon}></i> {boton1C.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = {() => {
                    this.solicitar()
                }}
                updState = {this.closeWindow()}/>
        );
    }

    modal = () => {
        let { openModal, requisitos, requisitosCon, DatosPersonales, qr } = this.state;
        const { seccionesSelectFull, InscripcionDatos, tipoInsc, periodoAct, datosPersonales, costoInsc, qrInsc } = this.state;

        if (openModal === false) return null
        
        return (
            <ModalReports 
                reporte={<PlanillaAdmision
                    requisitos = {requisitos}
                    requisitosCon = {requisitosCon}
                    datos = {DatosPersonales[0]}
                    periodo = {periodo}
                    carrera = {carrera}
                    token = {token}
                    fecha = {fecha}
                    cita = {cita}
                    qrCode = {qr}

                    data = {seccionesSelectFull}
                    dataInscripcion = {InscripcionDatos}
                    tipoInsc = {tipoInsc}
                    periodo2 = {periodoAct}
                    dataEst = {datosPersonales}
                    cuotas = {cuotas}
                    cuotaN = {cuotaN}
                    creditos = {unCr}
                    monto = {unBs}
                    inscripcion = {costoInsc}
                    qr = {qrInsc}
                />}
                titulo={"Impresión de Planilla de Admisión"}
                display= "block"
                cerrar = {() => {this.setState({openModal:false})}}
                />
        )
    }

    totalAPagar = () => {
        let inscript = this.state.costoInsc
        
        if (status === "1") return (
            <React.Fragment>
                <div className="text-danger">
                    Total a pagar <strong>{(parseFloat(unBs) + parseFloat(inscript.replace(' Bs.', ''))).toFixed(2)} Bs.</strong>
                </div>
                <div style={{fontSize: 10}}>Si ya realizaste la transferencia ve a <strong>ESTADO DE CUENTA</strong> para registrarla y agilizar el proceso</div>
            </React.Fragment>
        )
        return null;
    }

    botones = () => {
        const { button, button2 } = this.state;
        switch (status) {
            case "":
                switch (parseInt(statusUser)) {
                    case 1:
                        return (
                            <button className="btn btn-primary" disabled={button1} onClick={ () => {
                                this.setState({openW2: true, openW3: false,})
                            }} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button>
                        )
                    case 2:
                        /* Datos de perfil no validados */
                        let mensaje1 = (
                            <Popover bsSize="large" id="mensaje">
                                <div className="custom-alert-danger" align="center">No puedes realizar esta petición</div>
                                <div style={{marginTop: 5}} align="justify">
                                    Tienes abierta una solicitud de datos de perfil. Espera que esta solicitud sea rechazada para poder realizar el proceso de admisión
                                </div>
                            </Popover>
                        )

                        return (
                            <OverlayTrigger trigger="focus" placement="right" overlay={mensaje1}>
                                <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                            </OverlayTrigger>
                        )
                    case 3:
                        /* Cuenta validada */
                        let mensaje2 = (
                            <Popover bsSize="large" id="mensaje">
                                <div className="custom-alert-danger" align="center">No puedes realizar esta petición</div>
                                <div style={{marginTop: 5}} align="justify">
                                    Actualmente tu cuenta esta validada y no necesitas realizar el proceso de admisión
                                </div>
                            </Popover>
                        )

                        return (
                            <OverlayTrigger trigger="focus" placement="right" overlay={mensaje2}>
                                <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                            </OverlayTrigger>
                        )
                    case 4:
                        return (
                            <button className="btn btn-primary" disabled={button1} onClick={ () => {
                                this.setState({openW2: true, openW3: false,})
                            }} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button>
                        )
                    case 5:
                        /* return (
                            <button className="btn btn-primary" disabled={button1} onClick={ () => {
                                this.setState({openW2: true})
                            }} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button>
                        ) */
                        let mensaje3 = (
                            <Popover bsSize="large" id="mensaje">
                                <div className="custom-alert-danger" align="center">No puedes realizar esta petición</div>
                                <div style={{marginTop: 5}} align="justify">
                                    No necesitas realizar el proceso de admisión
                                </div>
                            </Popover>
                        )

                        return (
                            <OverlayTrigger trigger="focus" placement="right" overlay={mensaje3}>
                                <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                            </OverlayTrigger>
                        )
                    default:
                        return (<button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className = "fa fa-spinner fa-spin" style={{fontSize:16}}></i> Espera</button>)
                    }
                
            case "0":
                let mensaje = (
                    <Popover bsSize="large" id="mensaje">
                        <div className="custom-alert-danger">Ya has hecho este proceso</div>
                        <div style={{marginTop: 5}} align="justify">
                            Ya realizaste el proceso de admisión, imprime la planilla y lleva los documentos a admistración y espera un email con la respuesta a tu solicitud
                        </div>
                    </Popover>
                )

                return(
                    <div className="btn-group">
                        <button className="btn btn-primary" onClick={() => {this.setState({openModal: true})}} disabled={button1} style={{borderWidth:1}}><i className= {button2.icon} style={{fontSize:16}}></i> {button2.text}</button>
                        <OverlayTrigger trigger="focus" placement="right" overlay={mensaje}>
                            <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                        </OverlayTrigger>
                    </div>
                )
            case "1":
                let mensaje2 = (
                    <Popover bsSize="large" id="mensaje">
                        <div className="custom-alert-danger">Ya has hecho este proceso</div>
                        <div style={{marginTop: 5}} align="justify">
                            Ya realizaste el proceso de admisión, imprime las planillas y lleva los documentos a admistración
                        </div>
                    </Popover>
                )

                return(
                    <div className="btn-group">
                    <button className="btn btn-primary" onClick={() => {this.setState({openModal: true})}} disabled={button1} style={{borderWidth:1}}><i className= {button2.icon} style={{fontSize:16}}></i> {button2.text}</button>
                        <OverlayTrigger trigger="focus" placement="right" overlay={mensaje2}>
                            <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                        </OverlayTrigger>
                    </div>
                )
            case "2":
                let mensaje3 = (
                    <Popover bsSize="large" id="mensaje">
                        <div className="custom-alert-danger">Ya has hecho este proceso</div>
                        <div style={{marginTop: 5}} align="justify">
                            Ya te encuentras inscrito y no necesitas volver a realizar este proceso
                        </div>
                    </Popover>
                )

                return(
                    <div className="btn-group">
                    {/* <button className="btn btn-primary" onClick={() => {this.setState({openModal: true})}} disabled={button1} style={{borderWidth:1}}><i className= {button2.icon} style={{fontSize:16}}></i> {button2.text}</button> */}
                        <OverlayTrigger trigger="focus" placement="right" overlay={mensaje3}>
                            <button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className= {button.icon} style={{fontSize:16}}></i> {button.text}</button> 
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (<button className="btn btn-primary" disabled={button1} style={{borderWidth:1}}><i className = "fa fa-spinner fa-spin" style={{fontSize:16}}></i> Espera</button>)
        } 
    }

    contenido = () => {
        let { periodoSelect, periodos, carreraSelect, carreras, perfil, documentos, cantErrores } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-warning">
                    <Row>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={periodoSelect}
                                onChange={this.valorPeriodo}
                                options={periodos}
                            />
                            <div className="text-muted" style={{fontSize: 10}}>Selecciona un periodo académico</div>
                        </Col>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={carreraSelect}
                                onChange={this.valorCarrera}
                                options={carreras}
                            />
                            <div className="text-muted" style={{fontSize: 10}}>Selecciona para ver las carreras disponibles</div>
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-10">
                    <Col md={12}>
                        <PanelGroup accordion activeKey={perfil} className="custom-alert-info">
                            {this.perfil()}
                        </PanelGroup>
                    </Col>
                    <Col md={12}>
                        <PanelGroup accordion activeKey={documentos} className="custom-alert-info">
                            {this.documentos()}
                        </PanelGroup>
                    </Col>
                    {/* <Col md = {12}>
                        <RequisitosAdjuntos setFile1 = {(file) => {this.setState({file1: file})}}
                            setFile2 = {(file) => {this.setState({file2: file})}}
                            setFile3 = {(file) => {this.setState({file3: file})}}
                            setFile4 = {(file) => {this.setState({file4: file})}}
                        />
                    </Col> */}
                    <Col md={12}>
                        <div className="text-danger" style={{fontSize: 11}}>{ cantErrores }</div>
                    </Col>
                    <Col md ={6} className = "custom-mt-10">
                        {this.totalAPagar()}
                    </Col>
                    <Col md ={6} align="right" className = "custom-mt-10">
                        {this.botones()}
                    </Col>
                </Row>

            </React.Fragment>
        )
    }

    add = () => {

    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <div className="custom-alert-danger" style={{fontSize: 11}} align="justify">
                        Este módulo es para las personas que aspiran un cupo en la institución. Si eres estudiante regular, ingresa a <strong>Mi Perfil</strong> para modificar tus datos personales
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <div className="custom-alert-warning" style={{fontSize: 11}} align="justify">
                        Antes de comenzar el proceso de admisión asegúrate de tener a la mano los documentos que se solicitan ya que se  te otorgará una cita.
                        <div><strong>Actualmente la asignación de citas es de: {this.state.diasEntrega}</strong></div>
                        <div>Dependiendo de la demanda esta fecha puede incrementarse</div>
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    En primer lugar debes seleccionar el periodo académico deseado y la  carrera.
                    <div style={{fontSize: 10}}><strong>Nota: Las carreras sin cupo para el periodo seleccionado no se mostrarán en el listado</strong></div>
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Acerca de los datos personales</strong>
                </Col>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Cédula</strong>
                </Col>
                <Col md={9} align="justify">
                    En esta sección debes completar la información sin errores.
                    El campo Cédula debe ser escrito solo con numeros sin espacios ni puntos
                </Col>
            </Row>
            <Row>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Nombres Apellidos</strong>
                </Col>
                <Col md={9} align="justify">
                    Completa estos campos tal y como aparece en tu documento de identidad (Partida de Nacimiento o Pasaporte)
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Acerca de los datos de nacimiento</strong>
                </Col>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Lugar de Nacimiento</strong>
                </Col>
                <Col md={9} align="justify">
                    En esta sección debes comenzar primero indicando el País | Estado | Ciudad | Municipio | Parroquia.
                    Luego debes completar la Avenida o Calle y el Num de Casa / Edificio / Quinta
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Acerca de la dirección de habitación</strong>
                </Col>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Lugar</strong>
                </Col>
                <Col md={9} align="justify">
                    De la misma forma que llenaste los datos de nacimiento, debes especificar tu dirección actual.
                </Col>
            </Row>
            <Row>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Teléfonos</strong>
                </Col>
                <Col md={9} align="justify">
                    Completa los campos indicando el formato correcto para los números de telefono. Ej: <span style={{color:"#1f2f6e"}}>04140000000</span>. Solo indicando números
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <strong style={{color:"#CFAB75"}}>Acerca de los datos del representante</strong>
                </Col>
                <Col md={3} align="left" style={{fontSize:12}}>
                    <strong>Datos Generales</strong>
                </Col>
                <Col md={9} align="justify">
                    Estos datos solo son de caracter <strong>Obligatorio</strong> si eres menor de edad. En caso contrario omite esta información.
                    <br />
                    Para el llenado de dichos datos se deben seguir las mismas instrucciones de los datos personales.
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Documentos a consignar</strong>
                </Col>
                <Col md={12} align="justify">
                    Debes elegir cuales son los documentos que aplican para su solicitud. Toma en consideración que estos deben tener vista al original al momoento de consignarlos
                </Col>
                <Col md={12} align="justify">
                    Para seleccionar un requisito haz click en el boton <Switch
                        height={12}
                        width={24}
                        onChange={this.add()}
                        checked={false}
                    /> y este pasará automaticamente al estado <Switch
                        height={12}
                        width={24}
                        onChange={this.add()}
                        checked={true}
                    /> indicandote que ha sido seleccionado
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={12}>
                    <strong style={{color:"#A0555C"}}>Completando el proceso de Admisión</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez llenado todos los campos es hora de culminar el proceso de admisión. Para esto verifica que has colocado los datos de manera correcta
                    y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-paper-plane"></i> Enviar Solicitud</button>
                    <div style={{marginTop: 5}}>
                        Luego de aceptar te aparecerá el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}>
                            <i className="fa fa-print"></i> Imprimir Planillas
                        </button>
                    </div>
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={12} align="justify">
                    <strong>Nota: Luego de hacer el proceso de admisión deberás llevar la documentación en el dia indicado en la planilla, de lo contrario tu solicitud será rechazada automáticamente</strong>
                </Col>
            </Row>
        </React.Fragment>
    )

    render() {
        let { notificacionClass, notificacionText, notificacionIcon, notificacionStyles } = this.state;

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className={notificacionClass} style={{padding:10}}>
                            <Row>
                                <Col md={11}>
                                <div>{notificacionText}</div>
                                </Col>
                                <Col md={1}><i className={notificacionIcon} style={notificacionStyles}></i></Col>
                            </Row>
                        </div>
                        <div style={{borderRadius: "4px 4px", marginTop:10}}>
                            <CustomCard
                                title= "Admisión"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Admisión</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModal()}
                {this.modal()}
                {this.modalPago()}
                
            </div>
        );
    }
}
 
export default Admision;


// WEBPACK FOOTER //
// ./src/views/Admision/Admision.jsx